<template>
  <doughnut title="Tariffs" :apiData="latest" />
</template>

<script>
import { mapActions, mapState } from 'vuex'

import Doughnut from '@/components/Doughnut'

export default {
  name: 'CJMTariffsLatest',
  components: {
    Doughnut,
  },
  methods: {
    ...mapActions('cjm/tariffs', ['getLatest']),
  },
  computed: {
    ...mapState('cjm/tariffs', ['latest']),
  },
  async created() {
    this.getLatest()
  },
}
</script>
